import { useQuery } from '@tanstack/react-query'
import { getBrainerConfig } from '../api/brainer'

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-dd HH:ii:ss'

export function applyDateFormat(raw: string | null | undefined, format: string): string {
  if (!raw) return '—'
  const d = new Date(raw)
  if (isNaN(d.getTime())) return String(raw)
  return format
    .replace('YYYY', d.getFullYear().toString())
    .replace('MM',   String(d.getMonth() + 1).padStart(2, '0'))
    .replace('dd',   String(d.getDate()).padStart(2, '0'))
    .replace('HH',   String(d.getHours()).padStart(2, '0'))
    .replace('ii',   String(d.getMinutes()).padStart(2, '0'))
    .replace('ss',   String(d.getSeconds()).padStart(2, '0'))
}

export function useDateFmt() {
  const { data: config = [] } = useQuery({
    queryKey: ['brainer-config'],
    queryFn: () => getBrainerConfig().then(r => r.data),
    staleTime: 5 * 60 * 1000,
  })
  const format = (config as any[]).find((p: any) => p.key === 'DATE_FORMAT')?.value || DEFAULT_DATE_FORMAT
  return (d: string | null | undefined) => applyDateFormat(d, format)
}
